import LyAutoSelect from './src/main'

LyAutoSelect.install = function (Vue) {
    Vue.component(LyAutoSelect.name, LyAutoSelect)
}

export default LyAutoSelect